import { useModules } from '@entities/common/index.ts';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { PERMISSIONS_ENUM } from '@src/api/common.ts';

export const useModuleByCodeParam = () => {
  const { code = '' } = useParams();
  const { moduleByCode } = useModules();
  const module = useMemo(() => {
    return moduleByCode(code);
  }, [moduleByCode, code]);

  const permissions = {
    can_sell: !!module?.permissions.find((perm: PERMISSIONS_ENUM) => perm === 'can_sell'),
    can_buy: !!module?.permissions.find((perm: PERMISSIONS_ENUM) => perm === 'can_buy'),
  };

  return { code, moduleId: module?.id, module, permissions };
};
